import { render, staticRenderFns } from "./HeaderSection.vue?vue&type=template&id=76aab786&"
import script from "./HeaderSection.vue?vue&type=script&lang=ts&"
export * from "./HeaderSection.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\vNextBuildV3\\29\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('76aab786', component.options)
    } else {
      api.reload('76aab786', component.options)
    }
    module.hot.accept("./HeaderSection.vue?vue&type=template&id=76aab786&", function () {
      api.rerender('76aab786', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueApp/common/components/HeaderSection.vue"
export default component.exports